module.exports = __webpack_public_path__ + "img/Tktfox_Logo.9ebc2b7a.svg";